import { render } from "./ModalSimple.vue?vue&type=template&id=72812283&scoped=true"
import script from "./ModalSimple.vue?vue&type=script&lang=js"
export * from "./ModalSimple.vue?vue&type=script&lang=js"

import "./ModalSimple.vue?vue&type=style&index=0&id=72812283&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72812283"]])

export default __exports__